import { SHOPIFY_STORE_BRAND } from '@portal/config/base';
import { type EcommerceItem } from 'analytics/events/ecommerce';
import { ItemListName } from 'analytics/events/checkoutMembers';
import type { CartLine, DiscountCode } from 'api/shopifyV2/types';
import { StoreEnum } from 'schema/storeCode';

type mapCartLinesToGAEventsEcommerceItemsArguments = {
  cartLines: CartLine[];
  currency: string;
  cartDiscountCodes: DiscountCode[];
  store: StoreEnum;
};

export function mapCartLinesToGAEventsEcommerceItems({
  cartLines,
  currency,
  cartDiscountCodes,
  store
}: mapCartLinesToGAEventsEcommerceItemsArguments) {
  return cartLines.map((item: CartLine, index: number) => {
    // parsing the cart line attributes to get the item category
    const hasSubscriptionAttribute = item?.attributes?.some(
      (attr) => attr.key === '__shop_subscriptions' && attr.value === 'true'
    );
    const itemCategory = hasSubscriptionAttribute ? ItemListName.Subscription : ItemListName.OTP;
    const frequency = item?.merchandise.title.replace(/[^\d]/g, '');

    return {
      item_checkout_type: 'unified',
      item_id: item.id,
      item_name: item.merchandise.product.title,
      item_brand: SHOPIFY_STORE_BRAND[store],
      item_category: itemCategory,
      item_category2: hasSubscriptionAttribute ? frequency : undefined,
      variant_id: item.merchandise.id,
      price: item.merchandise.priceV2.amount,
      quantity: item.quantity,
      discount: cartDiscountCodes[0]?.code,
      index: index + 1,
      currency
    } satisfies EcommerceItem;
  });
}
